import { GetCallContactList, useUserLeaveCallListMutation } from "@bonliva-crm/graphql";
import { CallOrContactList, HookProps } from "../utils";

export function useUserLeaveCallList(props: HookProps) {
  const [userLeaveCallListMutation] = useUserLeaveCallListMutation({
    onError: (e) => {
      console.error(e);
      props.onError && props.onError(e);
    },
    onCompleted: () => {
      props.onCompleted && props.onCompleted();
    },
    refetchQueries: [GetCallContactList.OperationName]
  });

  const userLeaveCallList = (listToLeave: CallOrContactList) => {
    userLeaveCallListMutation({
      variables: { id: listToLeave._id },
      optimisticResponse: (vars) => ({
        leaveCallList: {
          __typename: "CallListOpResult",
          callList: {
            ...listToLeave,
            members: listToLeave.members.filter((m) => m.PersonId !== vars.id),
            deleted: listToLeave.members.length === 1
          }
        }
      })
    });
  };

  return { userLeaveCallList };
}
